export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.git.mami.kos';
export const APP_STORE_URL =
  'https://apps.apple.com/id/app/mamikos-cari-sewa-kos-mudah/id1055272843';

export const MAMIHELP_URL =
  process.env.MAMIHELP_URL || 'https://help.mamikos.com';
